import { Sparkles } from "lucide-react";
import type { AppShell } from "@/lib/navigation";

type ShellBrandProps = {
  shell: AppShell;
  compact?: boolean;
  className?: string;
};

export function ShellBrand({
  shell,
  compact = false,
  className = "",
}: ShellBrandProps) {
  if (shell === "shortpay") {
    return (
      <div className={`inline-flex items-center gap-2 ${className}`}>
        <span
          data-testid="shortpay-shell-icon"
          aria-hidden="true"
          className="inline-flex h-9 w-9 items-center justify-center rounded-md bg-sage text-text-inverse"
        >
          <Sparkles className="h-5 w-5" aria-hidden="true" />
        </span>
        <span
          className={`font-semibold tracking-wide text-text-primary ${
            compact ? "text-base" : "text-xl"
          }`}
        >
          Shortpay
        </span>
      </div>
    );
  }

  return (
    <img
      src="/brand/benecrm-logo.png"
      alt="BeneCRM"
      className={`h-8 w-auto ${className}`}
    />
  );
}
